define('json', function () {
    return {
        load: function (name, require, onload, config) {
            Cortona3DSolo.app.util.loadResource(require.toUrl(name), 'application/json', 'json')
                .then(function (xhr) {
                    if (xhr.response === null) {
                        throw new Error('Failed parsing JSON file "' + name + '"');
                    } else if (typeof xhr.response === 'string') {
                        var json = JSON.parse(xhr.response);
                        if (json) {
                            onload(json);
                        } else {
                            throw new Error('Failed parsing JSON file "' + name + '"');
                        }
                    } else {
                        onload(xhr.response);
                    }
                })
                .catch(onload.error);
        }
    };
});